/**
 * @generated SignedSource<<25dfc1f0abf6aa68b1d10618d70a7b5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateResolutionStatusInput = {
  resolutionId: string;
  status?: string | null;
};
export type useReportResolutionUpdateStatusMutation$variables = {
  input: UpdateResolutionStatusInput;
  resolutionSection?: string | null;
  anomalies?: ReadonlyArray<string | null> | null;
};
export type useReportResolutionUpdateStatusMutation$data = {
  readonly updateResolutionStatus: {
    readonly reportResolution: {
      readonly id: string;
      readonly currentValue: any | null;
      readonly initialValue: any | null;
      readonly resolutionKind: string | null;
      readonly status: string | null;
      readonly updateStatus: string | null;
      readonly anomalyTypes: ReadonlyArray<any | null> | null;
      readonly report: {
        readonly reviewStatus: string | null;
        readonly resolutionProgress: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"ReportResolution_report" | "ReportResolutionTable_report">;
      } | null;
    };
  } | null;
};
export type useReportResolutionUpdateStatusMutation = {
  variables: useReportResolutionUpdateStatusMutation$variables;
  response: useReportResolutionUpdateStatusMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anomalies"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resolutionSection"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialValue",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolutionKind",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updateStatus",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anomalyTypes",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolutionProgress",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportResolutionUpdateStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UpdateResolutionStatusPayload",
        "kind": "LinkedField",
        "name": "updateResolutionStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportResolution",
            "kind": "LinkedField",
            "name": "reportResolution",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Report",
                "kind": "LinkedField",
                "name": "report",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReportResolution_report"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReportResolutionTable_report"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useReportResolutionUpdateStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UpdateResolutionStatusPayload",
        "kind": "LinkedField",
        "name": "updateResolutionStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportResolution",
            "kind": "LinkedField",
            "name": "reportResolution",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Report",
                "kind": "LinkedField",
                "name": "report",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": "pendingResolutions",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "condition",
                        "value": {
                          "updateStatus": "pending"
                        }
                      }
                    ],
                    "concreteType": "ReportResolutionsConnection",
                    "kind": "LinkedField",
                    "name": "reportResolutions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnomalyCount",
                    "kind": "LinkedField",
                    "name": "anomalyCounts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "anomalies",
                            "variableName": "anomalies"
                          },
                          {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "resolutionSection"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "input"
                      }
                    ],
                    "concreteType": "ReportResolutionsConnection",
                    "kind": "LinkedField",
                    "name": "filteredReportResolutions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportResolution",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseData",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d713d091e21d49b88ae5c45c422a462",
    "id": null,
    "metadata": {},
    "name": "useReportResolutionUpdateStatusMutation",
    "operationKind": "mutation",
    "text": "mutation useReportResolutionUpdateStatusMutation(\n  $input: UpdateResolutionStatusInput!\n  $resolutionSection: String\n  $anomalies: [String]\n) {\n  updateResolutionStatus(input: $input) {\n    reportResolution {\n      id\n      currentValue\n      initialValue\n      resolutionKind\n      status\n      updateStatus\n      anomalyTypes\n      report {\n        reviewStatus\n        resolutionProgress\n        ...ReportResolution_report\n        ...ReportResolutionTable_report\n        id\n      }\n    }\n  }\n}\n\nfragment ReportResolutionTable_report on Report {\n  filteredReportResolutions(input: {anomalies: $anomalies, status: $resolutionSection}) {\n    nodes {\n      id\n      anomalyTypes\n      currentValue\n      status\n      updateStatus\n      responseData\n      resolutionKind\n    }\n  }\n  id\n}\n\nfragment ReportResolution_report on Report {\n  id\n  reviewStatus\n  pendingResolutions: reportResolutions(condition: {updateStatus: \"pending\"}) {\n    totalCount\n  }\n  anomalyCounts {\n    type\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "22d9e9d5080c17653d89f6fc600e8742";

export default node;
